module.exports = __webpack_public_path__ + "static/media/static-1.749da48f.jpg";